import System from '@/views/system';
// import RouterView from '@/views/router-view';
import MPESARepaymentSteps from '@/views/MPESARepaymentSteps/index'
import RegisterCoinlist from '@/views/RegisterCoinlist/index'
import WaittingRepaymentResult from '@/views/WaittingRepaymentResult'
import Register from '@/views/register/index';
import ContactVerification from '@/views/contactVerification/index';
import LoanContract from '@/views/loanContract/index';
import LoanProcessing from '@/views/LoanProcessing/index';
import RepaymentMethodRush from '@/views/RepaymentMethod/rsrush/index';
import InviteFriends from '@/views/InviteFriends/index';
import PrivacyPolicy from '@/views/PrivacyPolicy/index';
import LuckyDraws from '@/views/LuckyDraws/index';
import TiedCardSteps from '@/views/TiedCardSteps/index';
import LendingLicence from '@/views/LendingLicence/index';
import CashPayment from '@/views/CashPayment/index';

const sysRoute = [
  {
    path: "MPESARepaymentSteps",
    component: MPESARepaymentSteps
  },
  {
    path: "RegisterCoinlist", // 引导注册界面
    component: RegisterCoinlist
  },
  {
    path: "WaittingRepaymentResult", // 等待还款结果界面-还款处理中
    component: WaittingRepaymentResult
  },
  {
    path: 'LoanProcessing/:app', // 信贷审核界面-信审通过-放款处理中1002  信审中-审核中-1001 信审失败-审核拒绝-1004
    component: LoanProcessing,
  },
  {
    path: "ContactVerification/:app",
    component: ContactVerification
  },
  {
    path: "loanContract/:app",
    component: LoanContract, // RouterView,
  },
  {
    path: "RepaymentMethod/rsrush", // 还款方式界面
    component: RepaymentMethodRush
  },
  {
    path: "InviteFriends/:app", // 邀请好友界面
    component: InviteFriends
  },
  {
    path: "PrivacyPolicy/:app", // 权限说明界面
    component: PrivacyPolicy
  },
  {
    path: "register/:app", // 注册界面
    component: Register,
  },
  {
    path: 'lucky-draws', // 优惠券界面
    component: LuckyDraws,
  },
  {
    path: 'TiedCardSteps', // 绑卡步骤界面 ?
    component: TiedCardSteps,
  },
  {
    path: 'LendingLicence',
    component: LendingLicence,
  },
  {
    path: 'CashPayment',
    component: CashPayment,
  }
]

const routes = [
  {
    path: "/h5",
    component: System,
    routes: setRouters(sysRoute, '/h5'),
  },
  { // 保留之前的url，使用mpesarepaymentsteps占过多的字符串。故修改为h5
    path: "/mpesarepaymentsteps",
    component: System,
    routes: setRouters(sysRoute, '/mpesarepaymentsteps'),
  },
]

// 递归设置fullPath
function setRouters (arr, path) {
  return arr.map(_ => {
    // 子列表里递归会有内存污染的问题 直接使用JSON会导致component里面代码失效
    // if (_.routes) {
    //   setRouters([..._.routes], _.path);
    // }
    return {
      ..._,
      path: path + '/' + _.path,
    }
  })
}

export default routes
